import { useQuery } from '@apollo/client';
import { loader } from 'graphql.macro';
import React, { FunctionComponent } from 'react';
import { ReactComponent as Clock } from '../../../../../assets/icons/clock.svg';
import { DivergenciaKpi } from './DivergenciaKpi';

const query = loader('../../queries/GetTempoMedioResolucao.gql');

const KpiTempoMedioResolucao: FunctionComponent = () => {
  const { loading, data } = useQuery<{
    getTempoMedioResolucaoDiasForLoggedUser: number;
  }>(query);
  let value = '--';
  if (data && data.getTempoMedioResolucaoDiasForLoggedUser) {
    value =
      data?.getTempoMedioResolucaoDiasForLoggedUser.toPrecision(2) + ' dias';
  }
  return (
    <DivergenciaKpi
      label='Tempo médio de resolução'
      value={value}
      icon={<Clock className='iconPrimary500' width={48} height={48}></Clock>}
      loading={loading}
    ></DivergenciaKpi>
  );
};

export default KpiTempoMedioResolucao;
